import crudHandlers from "./_crud";

// const initialState = {
//   sat_catalogs: {},
// }

export default (state, action) => {
  const { type } = action

  switch (type) {
    case 'LOAD_SAT_CATALOG': {
      const { name, catalog } = action.payload

      if (!state?.sat_catalogs) {
        state.sat_catalogs = {}
      }

      return {
        ...state,
        sat_catalogs: {
          ...state.sat_catalogs,
          [name]: catalog
        },
      }
    }

    case 'LOAD_SAT_CATALOGS': {
      if (!state?.sat_catalogs) {
        state.sat_catalogs = {}
      }

      return {
        ...state,
        sat_catalogs: {
          ...state.sat_catalogs,
          ...action.payload,
        },
      }
    }

    case 'ADD_SAT_CATALOG': {
      if (!state?.sat_catalogs) {
        state.sat_catalogs = {}
      }

      const { name, item } = action.payload
      const newItem = state.sat_catalogs[name]
        ? [...state.sat_catalogs[name]]
        : item

      if (state.sat_catalogs[name]) {
        for (const i of item) {
          if (state.sat_catalogs[name].find((e) => e.code === i.code)) continue
          newItem.push(i)
        }
      }

      return {
        ...state,
        sat_catalogs: {
          ...state.sat_catalogs,
          [name]: newItem,
        },
      }
    }

    default:
      state = crudHandlers(state, action, 'quote')

      return state
  }
}
